module.exports = __webpack_public_path__ + "img/launchpad-texture-moonriver.783c3762.jpg";